import React, { useEffect, useState } from 'react';
import { useAuth } from '../utils/AuthContext';
import { useParams } from 'react-router-dom';
import { getItenary } from '../api/commerce';
import { CONFIG } from "../config";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Iten.css";
import "../css/MediaModal.css";


const ProductItenary = () => {
  const {productId} = useParams(); 
  const { lang } = useParams();
  const [setlang, setLang] = useState("fa")
  const [product, setProduct] = useState(null);
  const [activeImg, setActiveImg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseurl = CONFIG.API_URL


 useEffect(() => {
  if (!productId) return;  

  setLoading(true);  
  getItenary(productId)
    .then(res => {
      setProduct(res);  
    })
    .catch(err => {
      setProduct(null);  
    })
    .finally(() => {
      setLoading(false); 
    });
  }, [productId]); 

  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


  if (loading) return <Loading />;  
  if (error) return <p>{setlang==="en"?"no success: ":"صفحه یافت نشد"}{error}</p>;


  return (
    <>
      <NavbarLog />
      <div className='iten-page'>
      <div className="iten-grid">
        <div className="iten-images">
          {/* Images */}
          {Array.isArray(product.images) && product.images.length > 0 &&
            product.images.map((img) => (
              <img
                key={img.id}
                src={baseurl+img.image}
                alt={product.name}
                className="iten-image"
                onClick={()=>setActiveImg(baseurl+img.image)}
              />
            ))
          }
          {/* Videos */}
          {Array.isArray(product.videos) && product.videos.length > 0 &&
            product.videos.map((vid) => (
              <video
                key={vid.id}
                src={baseurl+vid.video}
                alt={product.name}
                controls
                className="iten-image"
              />
            ))
          }

          {/* Fallback if no media */}
          {(!product.images?.length && !product.videos?.length) && (
            <p style={{margin:"20px"}}>{setlang==="en"?"No media available":"تصویری وجود ندارد"}</p>
          )}
        </div>

        {activeImg && (
          <div className="mediaModalOverlay" onClick={()=>setActiveImg(null)}>
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
              <button className="closeBtn" onClick={()=>setActiveImg(null)}>
                ×
              </button>
                <img src={activeImg} alt="" className="media" />
            </div>
          </div>
        )}


        <div className="iten-section">
          <h2>{product.name}</h2>
          {setlang === "en" ? (
            <div className={setlang === "en" ? "iten-section-info" : "iten-section-info-fa" }>
              {product.description && <p><strong>{setlang === "en" ? "Description: " : "توضیحات: " }</strong> {product.description}</p>}
              {product.artist && <p><strong>{setlang === "en" ? "By: " : "اثر: " }</strong> {product.artist}</p>}
              {product.category && <p><strong>{setlang === "en" ? "Category: " : "دسته‌بندی: " }</strong> {product.category}</p>}
              {product.style && <p><strong>{setlang === "en" ? "Style: " : "استایل: " }</strong> {product.style}</p>}
              {product.material && <p><strong>{setlang === "en" ? "Material: " : "جنس ساخت: " }</strong> {product.material}</p>}
              {product.length && <p><strong>{setlang === "en" ? "Length: " : "طول: " }</strong> {product.length} cm</p>}
              {product.width && <p><strong>{setlang === "en" ? "Width: " : "عرض: " }</strong> {product.width} cm</p>}
              {product.height && <p><strong>{setlang === "en" ? "Depth (Height): " : "عمق (ارتفاع): " }</strong> {product.height} cm</p>}
              {product.weight && <p><strong>{setlang === "en" ? "Weight: " : "وزن: " }</strong> {new Number(product.weight).toLocaleString()} Kg</p>}
              {product.feature_one && <p><strong>{setlang === "en" ? "Features: " : "ویژگی‌های خاص: " }</strong> {product.feature_one}</p>}
              {product.feature_two && <p><strong>{setlang === "en" ? "Basic Features: " : "دیگر ویژگی‌ها: " }</strong> {product.feature_two}</p>}
              <p><strong>{setlang === "en" ? "Is Biddable: " : "قابل مزایده؟: " }</strong>{product.is_biddable ? (setlang === "en" ? "Yes":"بله") : (setlang === "en" ? "No":"خیر")}</p>
              {product.is_biddable && product.bidding_deadline && <p><strong>{setlang === "en" ? "Bidding Deadline: " : "تاریخ پایان مزایده: " }</strong> {dayjs.utc(product.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm")}</p>}
              {product.delivered_by && <p><strong>{setlang === "en" ? "Delivery Mode: " : "روش ارسال محصول: " }</strong> {product.delivered_by}</p>}
              {product.pickup_address && <p><strong>{setlang === "en" ? "Delivery Details: " : "روش دریافت محصول: " }</strong> {product.pickup_address}</p>}
              {product.price && <div className='iten-productPrice'><span><strong>{setlang === "en" ? "Price: " : "قیمت: " }</strong></span> <span>IRT {new Number(product.price).toLocaleString()}</span></div>}
              {product.created_at && (
                <p><small>{setlang === "en" ? "Placed on" : " تاریخ آگهی: " } {new Date(product.created_at).toDateString()}</small></p>
              )}
            </div>
          ):(
            <div className="iten-section-info-fa">
              {product.description && 
                <div className='info-row-fa'>
                  <div><p> {product.description}</p></div>
                  <div style={{ fontWeight:"bold"}}><span> :توضیحات</span></div> 
                </div>
              }
              {product.artist && 
                <div className='info-row-fa'>
                  <div><span> {product.artist}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :اثر</span></div> 
                </div>
              }
              {product.category && 
                <div className='info-row-fa'>
                  <div><span> {product.category}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :دسته‌بندی</span></div> 
                </div>
              }
              {product.style && 
                <div className='info-row-fa'>
                  <div><span> {product.style}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :استایل</span></div> 
                </div>
              }
              {product.material && 
                <div className='info-row-fa'>
                  <div><span> {product.material}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :جنس ساخت</span></div> 
                </div>
              }
              {product.length && 
                <div className='info-row-fa'>
                  <div><span> {toPersiDigits(new Number(product.length).toLocaleString())}</span> cm</div>
                  <div style={{ fontWeight:"bold"}}><span> :طول</span></div> 
                </div>
              }
              {product.width && 
                <div className='info-row-fa'>
                  <div><span> {toPersiDigits(new Number(product.width).toLocaleString())}</span> cm</div>
                  <div style={{ fontWeight:"bold"}}><span> :عرض</span></div> 
                </div>
              }
              {product.height && 
                <div className='info-row-fa'>
                  <div><span> {toPersiDigits(new Number(product.height).toLocaleString())}</span> cm</div>
                  <div style={{ fontWeight:"bold"}}><span> :عمق (ارتفاع)</span></div> 
                </div>
              }
              {product.weight && 
                <div className='info-row-fa'>
                  <div><span> {toPersiDigits(new Number(product.weight).toLocaleString())}</span> Kg</div>
                  <div style={{ fontWeight:"bold"}}><span> :وزن</span></div> 
                </div>
              }
              {product.feature_one && 
                <div className='info-row-fa'>
                  <div><span> {product.feature_one}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :ویژگی‌های خاص</span></div> 
                </div>
              }
              {product.feature_two && 
                <div className='info-row-fa'>
                  <div><span> {product.feature_two}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :دیگر ویژگی‌ها</span></div> 
                </div>
              }
              {product && (
              <div className='info-row-fa'>
                <div><span> {product.is_biddable ? (setlang === "en" ? "Yes":"بله") : (setlang === "en" ? "No":"خیر")}</span></div>
                <div style={{ fontWeight:"bold"}}><span> قابل مزایده؟</span></div> 
              </div>
              )}
              {product.is_biddable && product.bidding_deadline && 
                <div className='info-row-fa'>
                  <div><span> {toPersiDigits(dayjs.utc(product.bidding_deadline).local().calendar("jalali").locale("fa").format("YYYY/MM/DD HH:mm"))}</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :تاریخ پایان مزایده</span></div> 
                </div>
              }
              {product.delivered_by && 
                <div className='info-row-fa'>
                  <div><span> {product.delivered_by }</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :روش ارسال محصول</span></div> 
                </div>
              }
              {product.pickup_address && 
                <div className='info-row-fa'>
                  <div><span> {product.pickup_address }</span></div>
                  <div style={{ fontWeight:"bold"}}><span> :روش دریافت محصول</span></div> 
                </div>
              }
              {product.price && 
                <div className='info-row-fa'>
                  <div className='iten-productPrice'><span>قیمت: </span><span> {toPersiDigits(new Number(product.price).toLocaleString())}</span> تومان <span> </span></div>
                </div>
              }
              {product.created_at && 
                <div className='info-row-fa'>
                  <div><small><span>    {product.created_at && toPersiDigits(dayjs.utc(product.created_at).local().calendar("jalali").locale("fa").format("YYYY/MM/DD"))} </span></small></div>
                  <div><small><span> :تاریخ آگهی</span></small></div> 
                </div>
              }
            </div>
          )}
        </div>
      </div>
      </div>
      <Footer />      
    </>
  );
}

export default ProductItenary;




